<script setup lang="ts">
import { GrammarText } from '@nora-monorepo/grammar-ui';

import type { GalleryFile } from '#ui-shared/components/gallery/gallery.types';
import { bgTertiary, textPrimary } from '#ui-shared/tailwind/helpers';
import { getFileIcon } from '#ui-shared/utils/get-file-icon';
import { prettyPrintFileSize } from '#ui-shared/utils/pretty-print-file-size';

interface GalleryFileCardProps {
  file: GalleryFile;
}

defineProps<GalleryFileCardProps>();

const emit = defineEmits<{
  open: [];
}>();
</script>

<template>
  <button
    type="button"
    class="w-96 h-96 flex justify-center flex-col rounded-xl cursor-pointer"
    :class="bgTertiary"
    @click.stop="emit('open')"
  >
    <span
      class="mi md-48 mx-auto mb-6 "
      :class="[getFileIcon(file.mimeType), textPrimary]"
    />

    <GrammarText
      class="line-clamp-3 text-center"
      size="large"
      :text="file.fileName"
    />

    <GrammarText
      class="text-center"
      :text="prettyPrintFileSize(file.size)"
    />
  </button>
</template>
